import React from 'react';
import PropTypes from 'prop-types';

const QuestionHeader = ({ title, subtitle }) => (
    <div>
      <p className="m-0 question-title">
        {title}
      </p>
      <small className="question-subtitle">{subtitle}</small>
    </div>
  );

QuestionHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

QuestionHeader.defaultProps = {
  title: '',
  subtitle: '',
};

export default QuestionHeader;
